import { listImportedMainRowsWithoutMatch, WorksheetJoin } from "../engine/joinSources";
import { messages } from "../engine/messageCatalogue";
import { MappedSheet } from "../engine/validationTypes";
import type { AnnotatedIssue } from "./annotatedFile";

// Notes the imported main-sheet rows that a later sheet has no match for
export function buildMainRowsWithoutMatchIssues(
  joins: WorksheetJoin[],
  importedSheets: Map<string, MappedSheet>
): AnnotatedIssue[] {
  return joins.flatMap((join) => {
    const importedRowNumbers = new Set(importedSheets.get(join.worksheet)?.rowNumbers ?? []);
    return listImportedMainRowsWithoutMatch(join, importedRowNumbers).flatMap(({ sheetName, rowNumbers }) =>
      rowNumbers.map((rowNumber) => ({
        worksheet: join.worksheet,
        rowNumber,
        message: messages.noMatchOnSheet(sheetName),
      }))
    );
  });
}
